import { WEB_API_URLS, WebApiService } from '@migros/web-api-service';
import { stringify } from 'qs';
import { ResponseStatus } from '../helpers';
import { ArticleType } from '../models/models';
const buildUrl = (path, params = {}) => `${WebApiService.getInstance().buildWidgetsUrl(path)}${stringify(params)}`;
export const buildArticlesUrl = (type, params = {}) => {
  const path = type === ArticleType.Product ? 'product_fragments_json' : 'discount_fragments_json';
  return buildUrl(path, params);
};
export const buildCategorizedArticlesUrl = (type, params = {}) => {
  const path = type === ArticleType.Product ? 'fragments/product_fragments_store_ordered_json' : 'fragments/discount_fragments_store_ordered_json';
  return buildUrl(path, params);
};
const extractTotalHitsFromResponse = response => {
  const totalHits = response.headers.get('Total-Hits');
  if (totalHits === null) {
    return 0;
  }
  return parseInt(totalHits, 10);
};
export const initWebApi = ({
  environment,
  webAPIKey
}) => {
  if (environment && webAPIKey) {
    try {
      WebApiService.getInstance();
      console.error('WebApiService is already initialized. Remove `environment` and `webAPIKey` from your widget props.');
    } catch {
      WebApiService.init(WEB_API_URLS[environment], {
        key: webAPIKey
      });
    }
  }
};
export const fetchProducts = async (params = {}) => {
  return fetchArticles(ArticleType.Product, params);
};
export const fetchOffers = async (params = {}) => {
  return fetchArticles(ArticleType.Discount, params);
};
export const fetchArticles = async (type, params = {}) => {
  const articleResponse = {
    entities: [],
    totalHits: 0,
    responseStatus: ResponseStatus.ok
  };
  try {
    const url = buildArticlesUrl(type, params);
    const response = await WebApiService.getInstance().fetch(url);
    if (response.ok) {
      articleResponse.entities = await response.json();
      articleResponse.totalHits = extractTotalHitsFromResponse(response);
      if (articleResponse.totalHits === 0) {
        articleResponse.responseStatus = ResponseStatus.empty;
      }
    } else {
      articleResponse.responseStatus = ResponseStatus.error;
    }
  } catch (error) {
    console.error(error);
    articleResponse.responseStatus = ResponseStatus.error;
  }
  return articleResponse;
};
export const fetchCategorizedProducts = async (params = {}) => {
  return fetchCategorizedArticles(ArticleType.Product, params);
};
export const fetchCategorizedOffers = async (params = {}) => {
  return fetchCategorizedArticles(ArticleType.Discount, params);
};
export const fetchCategorizedArticles = async (type, params = {}) => {
  const articleResponse = {
    entities: [],
    totalHits: 0,
    responseStatus: ResponseStatus.ok
  };
  try {
    const url = buildCategorizedArticlesUrl(type, params);
    const response = await WebApiService.getInstance().fetch(url);
    if (response.ok) {
      const data = await response.json();
      articleResponse.entities = normalizeCategorizedArticles(data, type);
      articleResponse.totalHits = extractTotalHitsFromResponse(response);
      if (articleResponse.totalHits === 0) {
        articleResponse.responseStatus = ResponseStatus.empty;
      }
    } else {
      articleResponse.responseStatus = ResponseStatus.error;
    }
  } catch (error) {
    console.error(error);
    articleResponse.responseStatus = ResponseStatus.error;
  }
  return articleResponse;
};
export const normalizeCategorizedArticles = (categories, type) => {
  const categoryNames = Object.keys(categories);
  return categoryNames.map(categoryName => {
    const articlesPropertyName = type === ArticleType.Product ? 'products' : 'discounts';
    return {
      name: categoryName,
      totalHits: categories[categoryName].totalHits,
      articles: categories[categoryName][articlesPropertyName]
    };
  });
};